export default function LegalBanner() {
  return null;
}
